// extracted by mini-css-extract-plugin
export default {"alertButton":"ServiceWorkerWrapper_alertButton__8MP03","toastIcon":"ServiceWorkerWrapper_toastIcon__B33aq","toastAlign":"ServiceWorkerWrapper_toastAlign__+4psw"};